import React from "react";
import styled from "styled-components";
import { ArrowRight, MyCart } from "../../assets/icons";
import { Colors } from "../../ColorConstants";
import { useNavigate } from "react-router-dom";
import Button from "../Buttons";

const BreadCrumb = ({ items, activeItem, showCart = false }) => {
  const navigate = useNavigate();
  return (
    <BreadCrumbContainer>
      <BreadcrumbSubContainer>
        {items?.map((value,index) => (
          <BreadCrumbItem
            key={index}
            label={value?.label}
            active={activeItem === value.label}
            path={value?.path}
          />
        ))}
      </BreadcrumbSubContainer>
      {showCart && (
        <ButtonContainer>
          <Button
            variant="filled"
            label="My Cart"
            startIcon={<MyCartImage src={MyCart} marginRight="0.3rem" />}
            padding="0.4rem 1.25rem"
            onClick={() => navigate('/app/cart')}
          />
        </ButtonContainer>
      )}
    </BreadCrumbContainer>
  );
};

const BreadCrumbItem = ({ arrow, label, active = false, path }) => {
  const navigate = useNavigate();

  const handleRoute = () => {
    navigate(path);
  };
  return (
    <BreadCrumbItemContainer active={active} onClick={handleRoute}>
      <BreadCrumbItemLabel active={active}>{label}</BreadCrumbItemLabel>
      {!active && <BreadCrumbItemDivider arrow={arrow} src={ArrowRight} />}
    </BreadCrumbItemContainer>
  );
};

const BreadCrumbContainer = styled.div`
  height: 6rem;
  background: ${Colors.darkBlue};
  padding: 0 20rem;
  display: flex;
  align-items: center;
  cursor: pointer;
  justify-content: space-between;
  @media only screen and (max-width: 1024px) {
    display: none;
  }
`;
const BreadcrumbSubContainer = styled.div`
  display: flex;
  flex-direction: row;
`;
const BreadCrumbItemContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding-left: 1rem;
  border-left: ${(props) =>
    props.active ? `2px solid ${Colors.electricBlue}` : "none"};
`;
const BreadCrumbItemLabel = styled.div`
  color: ${(props) => (props.active ? `${Colors.white}` : `${Colors.aqua}`)};
`;
const BreadCrumbItemDivider = styled.img`
  width: ${(props) => (props.arrow ? "1rem" : "0rem")};
  height: 1rem;
  padding-right: 1rem;
`;
const MyCartImage = styled.img`
  width: 1.1rem;
  height: 1.1rem;
  margin-right: ${(props) => props.marginRight};
`;
const ButtonContainer = styled.div`
  width: 15%;
`;

export default BreadCrumb;
